import React, { useContext, useEffect } from "react";
import { NavContext } from "../../state/NavContext";
import MovieList from "./components/MovieList";

export const Movies = () => {
  const { setActiveIndex, setIsSideBarActive } = useContext(NavContext);

  useEffect(() => {
    setActiveIndex("movies");
    setIsSideBarActive(false);
  }, [setActiveIndex, setIsSideBarActive]);

  return (
    <div>
      <MovieList maxItem={null} />
    </div>
  );
};

export default Movies;
